"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useBreakpoints;
var _breakpoints = _interopRequireDefault(require("./breakpoints"));
var _diagnostics = _interopRequireDefault(require("diagnostics"));
var _react = require("react");
var _canUseDom = _interopRequireDefault(require("./can-use-dom"));
if ((0, _canUseDom.default)()) {
  window.addEventListener('resize', () => {
    if (!_breakpoints.default.changed()) return;
    window.dispatchEvent(new CustomEvent('breakpoint:hook:changed', {
      detail: {
        breakpoint: _breakpoints.default.breakpoint
      }
    }));
  });
}
/**
 * @typedef {Object} Breakpoint
 * @prop {string} name The name of the breakpoint
 * @prop {number} width The minimum width of the breakpoint in pixels
 */
/**
 * @typedef {Object} Viewport
 * @prop {number} width The width of the viewport in pixels
 * @prop {number} height The height of the viewport in pixels
 */
/**
 * @typedef {Object} useBreakpointsState
 * @prop {Breakpoint} breakpoint The current breakpoint
 * @prop {Viewport} viewport The current viewport size
 */

/**
 * React hook to setup breakpoint handling with breakdancer
 *
 * @param  {...string} points List of breakpoint names to subscribe to
 * @returns {useBreakpointsState} State variables for current breakpoint and viewport
 */
function useBreakpoints() {
  for (var _len = arguments.length, points = new Array(_len), _key = 0; _key < _len; _key++) {
    points[_key] = arguments[_key];
  }
  const debug = (0, _diagnostics.default)('ux:use-breakpoints');
  const [breakpoint, setBreakpoint] = (0, _react.useState)('unknown');
  const [height, setHeight] = (0, _react.useState)(0);
  const [width, setWidth] = (0, _react.useState)(0);
  function _resize(_ref) {
    let {
      detail: newBreakpoint
    } = _ref;
    if (!points || !points.length) return;
    //
    // Find the nearest registered point by minimal distance from the actual width.
    //
    if (!points.includes(newBreakpoint)) {
      const distances = points.map(point => Math.abs(_breakpoints.default.compare(point, 'width')));
      newBreakpoint = points[distances.indexOf(Math.min(...distances))];
    }

    //
    // Check if the breakpoint is actually different Breakpoint might have changed based on nearest algorithm.
    //
    if (breakpoint === newBreakpoint) return;
    debug('updating state as breakpoint changed to %s', newBreakpoint);
    const viewport = _breakpoints.default.viewport();
    setHeight(viewport.height);
    setWidth(viewport.width);
    setBreakpoint(newBreakpoint);
  }
  (0, _react.useEffect)(() => {
    _resize({
      detail: _breakpoints.default.currently()
    });
    window.addEventListener('breakpoint:hook:changed', _resize);
    return () => {
      window.removeEventListener('breakpoint:hook:changed', _resize);
    };
  }, [breakpoint, debug, points, width, height]);
  return {
    breakpoint,
    viewport: {
      height,
      width
    }
  };
}